/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Spinner from '@atlaskit/spinner/spinner';

type LoadingSpinnerProps = {
	testId?: string;
};

export const LoadingSpinner = ({ testId }: LoadingSpinnerProps): React.JSX.Element => (
	<Box xcss={styles} testId={testId}>
		<Spinner />
	</Box>
);

const styles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'absolute',
	top: 'space.0',
	width: '100%',
	height: '100%',
	zIndex: 'blanket',
});
